<script>
import { GlobalBus } from '@services/bus'
import { CHAT_IA_EVENTOS } from '@constants/Text'
import { deveMostrarChatIaWidget } from '@modules/global/utils/chat-ia-widget-visivel'
import ChatView from '@modules/aawz-intelligence-v2/views/chat/view-chat.vue'
import Conversations from '@modules/aawz-intelligence-v2/components/conversations/conversations.vue'
import { historicoConversas } from '@modules/aawz-intelligence-v2/mixins/historico-conversas'
import TopChatIaPopUp from '@modules/global/components/top-chat-ia-pop-up/top-chat-ia-pop-up.vue'
import {
  agenteIdPorPersona,
  AGENTE_DEFAULT_ID,
} from '@modules/aawz-intelligence-v2/constants/Agentes'

export default {
  name: 'ChatIaPopUp',
  components: { ChatView, Conversations, TopChatIaPopUp },
  // Abrir / criar / renomear / apagar conversa: o mesmo bloco que o painel do
  // Hub usa. Aqui o agente é variável, então implementamos o gancho
  // `adotarAgenteDaConversa` que o mixin chama antes de carregar as mensagens.
  mixins: [historicoConversas],

  data() {
    return {
      modulesData: {
        finance: { color: '#3F5D59', name: 'Financeiro' },
        juridico: { color: '#E0904A', name: 'Jurídico' },
        captable: { color: '#E0904A', name: 'Jurídico' },
        estrategia: { color: '#BDA767', name: 'Estratégia' },
        valuation: { color: '#BDA767', name: 'Estratégia' },
        bi: { color: '#8E8E8E', name: 'BI' },
        'dashboard-bi': { color: '#8E8E8E', name: 'BI' },
        asset_allocation: { color: '#AF9692', name: 'Asset allocation' },
        consolidador: { color: '#AF9692', name: 'Consolidador' },
        comissoes: { color: '#286A62', name: 'Comissões' },
        comissionamento: { color: '#286A62', name: 'Comissionamento' },
        rh: { color: '#C485C3', name: 'Gestão de desempenho' },
      },

      showChat: false,
      // Dono da selecao nesta superficie. Nasce no MESMO valor que o `ChatView`
      // assume sozinho (ele deriva do default da prop `persona`), entao os dois
      // ja nascem de acordo; dai em diante se mantem em sincronia pela prop
      // `agenteId` e pelo evento `agent-change`.
      agenteSelecionadoId: AGENTE_DEFAULT_ID,
      // Pergunta pedida de fora (`CHAT_IA_EVENTOS.ABRIR_COM_PERGUNTA`). Vai
      // ao `ChatView` como `perguntaInicial`: se ele já está montado, o
      // watcher dele envia; se o popup estava fechado, ele monta e envia.
      perguntaInicial: '',
      enviarPerguntaInicial: true,
    }
  },
  computed: {
    // Mesma FONTE que o `showChatIaWidget` do layout — antes eram duas cópias
    // da mesma regra, e elas divergiram. Ver `utils/chat-ia-widget-visivel.js`.
    showPopUp() {
      return deveMostrarChatIaWidget({
        routeName: this.$route.name,
        user: this.$currentUser(),
        access: this.$access,
      })
    },

    dataModule() {
      const routeName = this.$route.name

      const nameModule =
        routeName && routeName.includes('.')
          ? routeName.split('.')[0]
          : routeName

      const data = this.modulesData[nameModule]

      return data || {}
    },
  },

  watch: {
    // Fechou: a próxima abertura não pode reenviar a pergunta antiga.
    showChat(aberto) {
      if (!aberto) this.perguntaInicial = ''
    },
  },
  created() {
    GlobalBus.$on(CHAT_IA_EVENTOS.ABRIR_COM_PERGUNTA, this.abrirComPergunta)
  },
  beforeDestroy() {
    GlobalBus.$off(CHAT_IA_EVENTOS.ABRIR_COM_PERGUNTA, this.abrirComPergunta)
  },

  methods: {
    abrirComPergunta(payload) {
      const pergunta = ((payload || {}).pergunta || '').trim()
      if (!pergunta) return
      // Sem popup nesta rota (`/ia`, imersiva) não há para onde mandar: armar
      // estado aqui enviaria a pergunta atrasada na próxima rota com popup.
      if (!this.showPopUp) return
      this.enviarPerguntaInicial = (payload || {}).enviar !== false
      // Zera antes de setar: o mesmo texto duas vezes seguidas não trocaria
      // a prop, e o watcher do `ChatView` não dispararia a segunda.
      this.perguntaInicial = ''
      this.showChat = true
      this.mostrandoHistorico = false
      this.$nextTick(() => {
        this.perguntaInicial = pergunta
      })
    },
    // Seleciona uma conversa do histórico e carrega suas mensagens no store v2
    // (espelha selecionarConversa do ChatView v2). Fecha o painel de histórico.
    // Quem popula a lista no store é o `carregarConversas` do ViewChat, que
    // filtra pela persona ATIVA — certo para o chat, errado para o histórico,
    // que agora mostra todos os agentes. Recarregar na abertura é o que faz as
    // duas coisas conviverem sem o motor precisar saber do histórico.
    // A troca precisa acontecer ANTES de carregar as mensagens: o watcher de
    // `agenteId` no ViewChat chama `novaConversa()`, que limparia exatamente a
    // conversa que acabamos de abrir. Um tick separa as duas coisas.
    async adotarAgenteDaConversa(conversation) {
      const alvo = agenteIdPorPersona(conversation.context)
      if (!alvo || alvo === this.agenteSelecionadoId) return
      this.agenteSelecionadoId = alvo
      await this.$nextTick()
    },
  },
}
</script>

<template>
  <div v-if="showPopUp" class="chat-ia-pop-up">
    <div
      class="chat-ia-pop-up__icon"
      :aria-label="
        showChat ? 'Fechar AAWZ Intelligence' : 'Abrir AAWZ Intelligence'
      "
      :style="{ backgroundColor: dataModule.color || 'var(--primary)' }"
      @click="showChat = !showChat"
    >
      <icon-svg
        :name="showChat ? 'close' : 'ia-head'"
        color="white"
        :size="showChat ? '28' : '44'"
      />
    </div>

    <v-slide-y-transition>
      <div v-if="showChat" class="chat-ia-pop-up-messages">
        <TopChatIaPopUp
          :showChat="showChat"
          :show-conversation="mostrandoHistorico"
          @setShowChat="showChat = !showChat"
          @setShowConversation="alternarHistorico"
          @setNewMessage="novaConversa"
        />

        <div class="chat-ia-pop-up-messages__content">
          <div
            v-show="!mostrandoHistorico"
            class="chat-ia-pop-up-messages__content__chat"
          >
            <ChatView
              :widget="true"
              :agente-id="agenteSelecionadoId"
              :pergunta-inicial="perguntaInicial"
              :enviar-pergunta-inicial="enviarPerguntaInicial"
              @agent-change="agenteSelecionadoId = $event"
            />
          </div>

          <div
            v-show="mostrandoHistorico"
            class="p-15 chat-ia-pop-up__conversation"
          >
            <!-- Sem `agentes`: o histórico deixou de filtrar por agente. O
                 gestor não lembra de qual agente era a conversa que procura, e
                 o filtro obrigava a adivinhar antes de achar. A lista vem
                 inteira, cada linha diz de quem é, e o clique é que troca o
                 agente (ver `abrirConversa`, no mixin). -->
            <Conversations
              v-if="mostrandoHistorico"
              @select="abrirConversa"
              @new-conversation="novaConversa"
              @delete="apagarConversa"
              @rename="renomearConversa"
            />
          </div>
        </div>
      </div>
    </v-slide-y-transition>
  </div>
</template>

<style lang="sass">
.chat-ia-pop-up
  // Item de flex normal dentro de #aawz-floating-dock (main.vue) — não é
  // mais position:fixed próprio. `position: relative` só existe pra manter
  // o containing block do painel expandido (&-messages abaixo — ver o
  // comentário lá pro posicionamento real, position:fixed top/bottom/right).
  position: relative
  font-family: Inter

  &__icon
    height: 71px
    width: 71px
    display: flex
    align-items: center
    justify-content: center
    border-radius: 100%
    box-shadow: 0px 4px 10px 0px #00000040
    transition: opacity 0.15s ease

    &:hover
      cursor: pointer
      opacity: .95

  &-messages
    // position:fixed (não absolute) — ancorado direto na viewport por
    // top+bottom, então a altura do painel é 100% do espaço disponível
    // entre o topo da tela e o FAB, em vez de um height fixo/capado que
    // sobrava espaço vazio em telas grandes (deliberado — mantido na
    // correção do MUST DO 2 do review do PR #1939). Containing block
    // continua correto mesmo se `.aawz-floating-dock` ganhar um transform
    // (estado "recolhido" — ver main.vue): o painel é "capturado" pelo
    // ancestral transformado e sai da viewport junto, como position:absolute
    // faria.
    position: fixed
    top: 56px
    // 103px = 87px (71px do FAB + 16px de gap) + 16px de folga extra — o
    // painel abre ACIMA do FAB (que continua visível, virando o botão de
    // fechar), nunca sobre ele.
    bottom: 103px
    // MUST DO 2 do review do PR #1939: era `right: 16px`, um número que não
    // batia com nada real — o dock (#aawz-floating-dock, main.vue) fica a
    // `right: 40px` da viewport, e como o `right` aqui é relativo à
    // viewport (position:fixed sem ancestral transformado), 16px deixava o
    // painel 24px pra fora do próprio dock (medido ao vivo: 111px de
    // desalinhamento real com o FAB do Chat IA especificamente, já que o
    // dock tem 2 widgets lado a lado). `right: 40px` alinha com a borda
    // real do dock — estável independente de quantos widgets ele tiver.
    right: 40px
    // Superfície quente do chat, não o cinza frio #F5F5F5: o popup inteiro
    // (header, chat e histórico) passou para a família quente, e o painel de
    // fundo era o único tom frio sobrando.
    background-color: var(--ia-content-bg)
    box-shadow: 0px 2px 10px 0px #00000040
    border-radius: 8px
    // Flex column: header (TopChatIaPopUp, altura natural) + content
    // (flex:1, preenche o resto). overflow:hidden clipa tudo nos cantos
    // arredondados do painel (header escuro + conteúdo branco).
    display: flex
    flex-direction: column
    overflow: hidden

    &__content
      // Mesmo tamanho pros dois estados (chat e histórico) — ver
      // .chat-ia-pop-up__conversation abaixo, que compartilha a altura.
      width: min(700px, 92vw)
      flex: 1
      min-height: 0

      // Wrapper que dá altura definida ao ChatView v2 (widget: height 100%).
      &__chat
        height: 100%
        overflow: hidden

  .chat-ia-pop-up__conversation
    // Mesma altura do &__content__chat acima — painel não pode "pular" de
    // tamanho ao alternar entre chat e histórico (Conversations v2 usa
    // height 100% + scroll interno, preenche o que vier daqui).
    height: 100%
    overflow: hidden
    // Mesma superfície quente do corpo do chat (--ia-content-bg). Branco aqui
    // deixava o histórico como a única tela clara do popup — o header já é
    // quente e o chat também, então alternar para o histórico piscava.
    background: var(--ia-content-bg)
</style>
